import React from 'react';
import { string, oneOfType, number } from 'prop-types';
import classnames from 'classnames';
import './Spec.scss';

export default function Spec({ className, label, value }) {
    const rootClassnames = classnames('spec', className);

    return (
        <div className={rootClassnames}>
            <div className="spec__label">{label}</div>
            <div className="spec__value">{value}</div>
        </div>
    );
}

Spec.propTypes = {
    className: string,
    label: string.isRequired,
    value: oneOfType([string, number]).isRequired,
};

Spec.defaultProps = {
    className: null,
};
